import React, { useRef, useEffect, useState } from 'react';
import { Rect, Transformer } from 'react-konva';
import { styled } from '@mui/material/styles';

// Import the concrete texture image
//import concreteTextureImage from './concrete-texture.jpg'; // Replace with the path to your concrete texture image

const Concrete = (props) => {
  const [showTransformer, setShowTransformer] = useState(false);
  const [selected, setSelected] = useState(false);

  const rectRef = useRef(null);
  const transformerRef = useRef(null);

  useEffect(() => {
    document.addEventListener('clearSelections', onClearSelections);

    return () => {
      document.removeEventListener('clearSelections', onClearSelections);
    };
  }, []);

  useEffect(() => {
    save();
  }, []);

  useEffect(() => {
    if (showTransformer) {
      transformerRef.current.nodes([rectRef.current]);
      transformerRef.current.getLayer().batchDraw();
    }
  }, [showTransformer]);

  const onClearSelections = (e) => {
    const target = e.detail.target;
    const hasParent = Boolean(target.parent);
    let hasNodes = false;
    if (hasParent) {
      hasNodes = Boolean(target.parent._nodes);
    }

    if (target === rectRef.current) {
      // setSelected(true);
      // setShowTransformer(true);
      // props.setSelected(rectRef);
      //skip
    } else if (hasParent && hasNodes && target.parent._nodes[0] === rectRef.current) {
      //skip
    } else {
      setSelected(false);
      setShowTransformer(false);
    }
  };

  const onSelect = (e) => {
    if (e.evt.button === 0 || e.evt.touches) {
      setShowTransformer(true);
      setSelected(true);
      props.setSelected(rectRef);
    }
  };

  const onTap = (e) => {
    if (e.evt.touches.length > 1) {
      //onContextMenu(e);
    } else {
      onSelect(e);
    }
  };

  const onDragEnd = (e) => {
    save();
  };

  const onTransformEnd = (e) => {
    save();
  };

  const save = () => {
    //console.log(rectRef.current.attrs);
    if (props.setSaveData) {
      return props.setSaveData({
        [props.id]: {
          id: props.id,
          key: props.id,
          type: 'Pool',
          x: rectRef.current.attrs.x,
          y: rectRef.current.attrs.y,
          width: rectRef.current.attrs.width,
          height: rectRef.current.attrs.height,
          scaleX: rectRef.current.attrs.scaleX || 1,
          scaleY: rectRef.current.attrs.scaleY || 1,
          rotation: rectRef.current.attrs.rotation
        }
      });
    }
  };

  return (
    <>
      {/* Apply concrete texture to the Rect */}
      <Rect
        {...props}
        onClick={onSelect}
        ref={rectRef}
        draggable={showTransformer}
        strokeScaleEnabled={false}
        onTouchStart={onTap}
        onDragEnd={onDragEnd}
        onTransformEnd={onTransformEnd}
        //fillPatternImage={concreteTextureImage} // Apply concrete texture image
        //fillPatternRepeat="repeat" // Repeat the texture pattern
        fill={'#b7b7b7'}
        opacity={0.5}
        stroke={'#003333'}
        strokeWidth={5}
      />
      {showTransformer && (
        <Transformer
          ref={transformerRef}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </>
  );
};

export default Concrete;
